let appConfig;

switch(process.env.REACT_APP_ENV) {
  case "development":
    appConfig = {
      basePluginUrl: 'http://localhost:3333',
      apiHost: 'https://stagingapi.videopeel.com',
      AWS:{
        SiteAssets: "https://s3.amazonaws.com/videopeel-development",
        S3bucket: "https://s3.amazonaws.com/videopeel-development",
        GateWayURL : "https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video",
        S3bucketName: "videopeel-development"
      },
      FACEBOOK:{
        appId: "223916434843000"
      },
    };
    break;

  case "staging":
    appConfig = {
      basePluginUrl: 'https://pluginstaging.videopeel.com',
      apiHost: 'https://stagingapi.videopeel.com',
      AWS:{
        SiteAssets: "https://s3.amazonaws.com/videopeel-development",
        S3bucket: "https://s3.amazonaws.com/videopeel-development",
        GateWayURL : "https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video",
        S3bucketName: "videopeel-development"
      },
    };
    break;

  case "production":
    appConfig = {
      basePluginUrl: 'https://plugin.videopeel.com',
      apiHost: 'https://api.videopeel.com',
      AWS:{
        SiteAssets: "https://d2fr8icwxgw12b.cloudfront.net",
        S3bucket: "https://s3.amazonaws.com/videopeel-production",
        GateWayURL : "https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/prod/process-video",
        S3bucketName: "videopeel-production"
      },
    };
    break;
  default:
    throw new Error('Unable to determine proper config.');
}

export const config = appConfig;



// WEBPACK FOOTER //
// ./src/config.js